import { useContent } from '../ContentContext';
import { PageHero, SectionHead, InfoCard, FestivalCard } from '../components/Common';

export default function Occasions() {
  const { occasions = [], festivals = [] } = useContent();

  return (
    <>
      <PageHero title="Perfect For Every Occasion" image={occasions[0]?.image} />

      <section>
        <div className="container">
          <SectionHead
            title="Serving Every Celebration"
            text="From grand weddings and festive feasts to everyday family meals, Golden Taj brings authentic taste and aroma to every table."
          />
          <div className="card-grid">
            {occasions.map((o) => (
              <InfoCard
                key={o.name}
                title={o.name}
                image={o.image}
                text={`Premium Basmati rice trusted for ${(o.name || '').toLowerCase()} — long grains, rich aroma and consistent results every time.`}
              />
            ))}
          </div>
        </div>
      </section>

      {festivals.length ? (
        <section className="alt-bg">
          <div className="container">
            <SectionHead
              title="Celebrating Every Festival With Golden Taj Rice"
              text="From festive feasts to family gatherings, Golden Taj Rice brings authentic taste and aroma to every special occasion."
            />
            <div className="festival-grid">
              {festivals.map((f) => <FestivalCard key={f.title} {...f} />)}
            </div>
          </div>
        </section>
      ) : null}
    </>
  );
}
